import DatePicker from 'vue2-datepicker';
import utils from './utils.js';
import { Validator } from 'simple-vue-validator';

export default {
    components: {
        DatePicker
    },
    props: ['selected_staff', 'staff_members', 'login_user_id', 'salon_selected', 'edit_break_id', 'edit_break_date', 'edit_break_start_time', 'edit_break_end_time', 'edit_break_notes','edit_break_created_date','edit_break_updated_date'],
    name: 'break_popover',
    data(){
        return {
            break_date : '',
            break_start_time : '',
            break_end_time : '',
            staff_selected: 0,
            break_notes: '',
            start_time_greater_than_end_time: false,
            break_created_date : '',
            break_updated_date: ''

        }
    },
    mounted(){
        this.break_date         = utils.date_from_sql_to_bookjoy_format(this.edit_break_date);
        this.staff_selected     = this.selected_staff;
        this.break_notes        = this.edit_break_notes;
        this.break_start_time   = utils.convert_datetime_to_bookjoy_time_format(this.edit_break_start_time);
        this.break_end_time     = utils.convert_datetime_to_bookjoy_time_format(this.edit_break_end_time);
        this.break_notes        = this.edit_break_notes;
        this.break_created_date = utils.convert_datetime_to_bookjoy_date_time_format(this.edit_break_created_date);
        this.break_updated_date = utils.convert_datetime_to_bookjoy_date_time_format(this.edit_break_updated_date);
        this.start_time_greater_than_end_time = false;
    },
    methods:{
        edit_break() {
            let _this = this;
            this.$validate().then(function (success) {
                if (success) {
                    var start_time = utils.time_from_bookjoy_format_to_sql(_this.break_start_time)
                    var end_time = utils.time_from_bookjoy_format_to_sql(_this.break_end_time)
                    if(!utils.comparing_startime_and_endtime(start_time, end_time))
                    {
                        _this.start_time_greater_than_end_time = true;
                        return;
                    }
                    _this.button_status_update('update_break_button')
                    _this.start_time_greater_than_end_time = false;
                    var duration = utils.time_duration_in_min(start_time, end_time)
                    _this.$store.dispatch('edit_break',[_this.$store.state.api,
                            _this.edit_break_id,
                            _this.salon_selected.store_id,
                            _this.staff_selected,
                            utils.date_from_bookjoy_format_to_sql(_this.break_date),
                            utils.date_from_bookjoy_format_to_sql(_this.break_date),
                            start_time,
                            end_time,
                            duration,
                            _this.break_notes,
                            _this.login_user_id,
                            _this.Constants.BOOKED_THROUGH_ADMIN,
                            _this.Constants.BOOKING_TYPE_EDIT_STAFF_BREAK
                    ]).then(()=>{
                        _this.$emit('update_events', 'edit_break_popup');
                    })
                }
            });            
        },
        time_validation(){
            var start_time = utils.time_from_bookjoy_format_to_sql(this.break_start_time)
            var end_time = utils.time_from_bookjoy_format_to_sql(this.break_end_time)
            if(!utils.comparing_startime_and_endtime(start_time, end_time)){
                this.start_time_greater_than_end_time = true;
            }else{
                this.start_time_greater_than_end_time = false;
            }
        },
        delete_break()
        {
            let _this = this;
            _this.button_status_update('delete_break_button')
            _this.$store.dispatch('delete_break',[
                _this.$store.state.api, _this.edit_break_id,_this.Constants.BOOKING_TYPE_DELETE_STAFF_BREAK
            ]).then(()=>{
                _this.$emit('update_events', 'edit_break_popup');
            })
        },
        button_status_update(button_clicked)
        {
            if(button_clicked == 'delete_break_button')
                document.getElementsByClassName('delete_break_button')[0].innerHTML="Please Wait";
            else if(button_clicked == 'update_break_button')
                document.getElementsByClassName('update_break_button')[0].innerHTML="Please Wait";

            document.getElementsByClassName('delete_break_button')[0].disabled=true;
            document.getElementsByClassName('update_break_button')[0].disabled=true;
        }
    },
    validators: {
        break_start_time: function (value) {
          return Validator.value(value).required();
        },
        break_end_time: function (value) {
            return Validator.value(value).required();
        },
        staff_selected: function (value) {
            return Validator.value(value).required();
        },
        break_date: function (value) {
            return Validator.value(value).required();
        },
    }

}